import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { device } from '../../../utils/helpers'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 175px;
  width: 225px;
  justify-content: space-between;
  text-align: center;

  @media ${device.tablet} {
    width: 135px;
    height: 116px;
  }

  @media ${device.laptopM} {
    width: 158px;
    height: 136px;
  }

  @media ${device.laptopL} {
    width: 190px;
    height: 166px;
  }

  @media ${device.desktop} {
    width: 260px;
    height: 225px;
  }
`

const IconWrapper = styled.div`
  display: flex;
  padding-bottom: 20px;

  @media ${device.desktop} {
    padding-bottom: 0;
  }
`

const Title = styled.h3`
  font-size: 24px;
  padding-bottom: 16px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;

  @media ${device.tablet} {
    font-size: 19px;
    padding-bottom: 12px;
  }

  @media ${device.laptopM} {
    font-size: 22.5px;
    padding-bottom: 14px;
  }

  @media ${device.laptopL} {
    font-size: 27px;
    padding-bottom: 16px;
  }

  @media ${device.desktop} {
    font-size: 36px;
    padding-bottom: 21px;
  }
`

const Description = styled.p`
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 12.8px;
  }

  @media ${device.laptopM} {
    font-size: 15px;
  }

  @media ${device.laptopL} {
    font-size: 18px;
  }

  @media ${device.desktop} {
    font-size: 24px;
  }
`

const Feature = ({ icon, title, description }) => {
  return (
    <Wrapper>
      <IconWrapper>
        {icon}
      </IconWrapper>
      <div>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </div>
    </Wrapper>
  )
}

Feature.propTypes = {
  /**
   * Icon used for the feature
   */
  icon: PropTypes.node.isRequired,

  /**
   * Title of the feature
   */
  title: PropTypes.string.isRequired,

  /**
   * Description of the feature
   */
  description: PropTypes.string.isRequired
}

export default Feature



// WEBPACK FOOTER //
// ./src/components/UI/Feature/index.js